import React, { useContext } from 'react';
import { AppInfoContext } from '../context/AppInfo';
import ProfileNavigation from './ProfileNavigation';

const ProfileWrapper = props => {
  const { width, height } = props;
  const { isMobile } = useContext(AppInfoContext);
  const newHeight = isMobile ? window.innerHeight - 40 : Math.min(window.innerHeight, height || 700);
  return (
    <>
      <div
        className='clinic-profile nice-scroll-0'
        style={{
          width: Math.min(window.innerWidth, width || 500),
          height: newHeight,
          zIndex: 2000,
          position: 'fixed',
          top: isMobile ? 20 : Math.max(window.innerHeight - 600 - 200, 0),
          left: isMobile ? 0 : Math.max(window.innerWidth - 400 - 100, 0),
          overflowY: 'overlay'
        }}
      >{
        props.open && (
          <ProfileNavigation
            backLabel={props.backLabel}
            back={props.back}
            open={props.open}
            maxWidth={Math.min(window.innerWidth, width || 500) + 30}
            zIndex={2100}
          />
        )
        }
        <div
          className='nice-scroll-0' style={{
            overflowY: 'scroll',
            position: 'absolute',
            height: newHeight,
            width: '100%',
            marginTop: -30,
            paddingTop: 30
          }}
        >
          {props.children}
        </div>
      </div>
    </>
  );
};

export default ProfileWrapper;
